/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {TempLimit} from '../models/TempLimit';
import type {UserLimitsRemoveRequest} from '../models/UserLimitsRemoveRequest';
import type {UserLimitsSaveRequest} from '../models/UserLimitsSaveRequest';

export interface GetUserTempLimits$Request {
    userId: number;
}

export interface GetUserTempLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserTempLimitsRequest = createAction<PayloadData<void, GetUserTempLimits$Request>>('USER_TEMPORARY_LIMITS__GET_USER_TEMP_LIMITS__REQUEST');
export const getUserTempLimitsSuccess = createAction<PayloadData<Array<TempLimit>, GetUserTempLimits$Request>>('USER_TEMPORARY_LIMITS__GET_USER_TEMP_LIMITS__SUCCESS');
export const getUserTempLimitsFailure = createAction<PayloadData<Error, GetUserTempLimits$Request, true>>('USER_TEMPORARY_LIMITS__GET_USER_TEMP_LIMITS__FAILURE');

export const getUserTempLimitsActions = [
    getUserTempLimitsRequest,
    getUserTempLimitsSuccess,
    getUserTempLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserTempLimits = (meta: GetUserTempLimits$Request, config?: GetUserTempLimits$Config) => {
    return {
        CALL_API: {
            types: getUserTempLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/temporaries-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveUserTemporaryLimit$Request {
    userId: number;
    userLimitsRemoveRequest: UserLimitsRemoveRequest;
}

export interface RemoveUserTemporaryLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeUserTemporaryLimitRequest = createAction<PayloadData<void, RemoveUserTemporaryLimit$Request>>('USER_TEMPORARY_LIMITS__REMOVE_USER_TEMPORARY_LIMIT__REQUEST');
export const removeUserTemporaryLimitSuccess = createAction<PayloadData<void, RemoveUserTemporaryLimit$Request>>('USER_TEMPORARY_LIMITS__REMOVE_USER_TEMPORARY_LIMIT__SUCCESS');
export const removeUserTemporaryLimitFailure = createAction<PayloadData<Error, RemoveUserTemporaryLimit$Request, true>>('USER_TEMPORARY_LIMITS__REMOVE_USER_TEMPORARY_LIMIT__FAILURE');

export const removeUserTemporaryLimitActions = [
    removeUserTemporaryLimitRequest,
    removeUserTemporaryLimitSuccess,
    removeUserTemporaryLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLimitsRemoveRequest} meta.userLimitsRemoveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeUserTemporaryLimit = (meta: RemoveUserTemporaryLimit$Request, config?: RemoveUserTemporaryLimit$Config) => {
    return {
        CALL_API: {
            types: removeUserTemporaryLimitActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/temporaries-limits`,
            TRANSPORT_REQUEST_BODY: meta.userLimitsRemoveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserTemporaryLimit$Request {
    userId: number;
    expiresOn: string;
    userLimitsSaveRequest: UserLimitsSaveRequest;
}

export interface SaveUserTemporaryLimit$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserTemporaryLimitRequest = createAction<PayloadData<void, SaveUserTemporaryLimit$Request>>('USER_TEMPORARY_LIMITS__SAVE_USER_TEMPORARY_LIMIT__REQUEST');
export const saveUserTemporaryLimitSuccess = createAction<PayloadData<void, SaveUserTemporaryLimit$Request>>('USER_TEMPORARY_LIMITS__SAVE_USER_TEMPORARY_LIMIT__SUCCESS');
export const saveUserTemporaryLimitFailure = createAction<PayloadData<Error, SaveUserTemporaryLimit$Request, true>>('USER_TEMPORARY_LIMITS__SAVE_USER_TEMPORARY_LIMIT__FAILURE');

export const saveUserTemporaryLimitActions = [
    saveUserTemporaryLimitRequest,
    saveUserTemporaryLimitSuccess,
    saveUserTemporaryLimitFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} meta.expiresOn
 * @param {UserLimitsSaveRequest} meta.userLimitsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserTemporaryLimit = (meta: SaveUserTemporaryLimit$Request, config?: SaveUserTemporaryLimit$Config) => {
    const TRANSPORT_GET_PARAMS = {
        expiresOn: meta.expiresOn,
    };
    return {
        CALL_API: {
            types: saveUserTemporaryLimitActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/users/${meta.userId}/temporaries-limits`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.userLimitsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

